class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <div class="sticky_form" data-sticky-add-to-cart>
        <div class="sticky_form_inner">
          <div class="sticky-top-btn hidden md:flex">
            <div class="sticky-arrow-up">
              <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.01584 4.04074C8.07425 4.09536 8.12486 4.14218 8.17547 4.1929C9.75229 5.773 11.3291 7.34919 12.9098 8.92929C12.9994 9.01902 13.0967 9.10876 13.2018 9.18679C13.8209 9.65106 14.7086 9.52622 15.1836 8.91759C15.6547 8.31286 15.5963 7.50915 15.0317 6.93954C13.3342 5.23459 11.6328 3.53355 9.93139 1.82861C9.65885 1.5516 9.39021 1.2707 9.12935 0.981987C8.54145 0.326539 7.43573 0.342145 6.87119 1.0132C6.75439 1.15365 6.6337 1.2863 6.50521 1.41505C5.34888 2.57769 4.18865 3.74033 3.02842 4.90297C2.32372 5.60914 1.61123 6.3114 0.914319 7.02927C0.170683 7.79396 0.470474 9.07364 1.47497 9.41307C2.07844 9.61985 2.60405 9.44819 3.05178 8.99952C4.64807 7.39601 6.25214 5.79641 7.85232 4.1929C7.90683 4.14218 7.95744 4.09536 8.01584 4.04074Z" fill="white"></path>
              </svg>
            </div>
            TOP
          </div>
          <div class="sticky-titlesmobile hidden md:flex"></div>
          <div class="new-container">
            <div class="sticky-add-to-cart">
              <form method="post" action="/cart/add" id="form-sticky" class="shopify-product-form">
                <div class="fully-wrapper">
                  <div class="product-price"></div>
                  <div class="item quantity">
                    <div class="qty-group">
                      <a href="#" class="minus button">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 498.98 284.49"><path d="M80.93 271.76A35 35 0 0 1 140.68 247l189.74 189.75L520.16 247a35 35 0 1 1 49.5 49.5L355.17 511a35 35 0 0 1-49.5 0L91.18 296.5a34.89 34.89 0 0 1-10.25-24.74z" transform="translate(-80.93 -236.76)"></path></svg>
                      </a>
                      <input type="text" name="quantity" value="1" min="1" pattern="[0-9]*">
                      <a href="#" class="plus button">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-up" viewBox="0 0 498.98 284.49"><path d="M579.91 486.24A35 35 0 0 1 520.16 511L330.42 321.25 140.68 511a35 35 0 1 1-49.5-49.5L305.67 247a35 35 0 0 1 49.5 0l214.49 214.5a34.89 34.89 0 0 1 10.25 24.74z" transform="translate(-80.93 -236.76)"></path></svg>
                      </a>
                    </div>
                  </div>
                  <div class="item action-wrapper">
                    <input type="hidden" name="id" value="">
                    <input data-sticky-btn-addtocart type="submit" name="add" class="btn btn--primary btn-sticky-add-to-cart" value="Add to cart">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    `;

    /* ===== Select elements ===== */
    const stickyForm = this.querySelector(".sticky_form");
    const stickyAtc = this.querySelector("[data-sticky-btn-addtocart]");
    const priceEl = this.querySelector(".product-price");
    const hiddenId = this.querySelector("input[name='id']");
    const qtyInput = this.querySelector("input[name='quantity']");
    const minus = this.querySelector(".minus");
    const plus = this.querySelector(".plus");
    const titlesContainer = this.querySelector(".sticky-titlesmobile");
    const topBtn = this.querySelector(".sticky-top-btn");

    const getMainProductForm = () =>
      document.querySelector("product-form form[data-type='add-to-cart-form']") ||
      document.querySelector("form[id^='product-form-']");

    const getMainVariantInput = () =>
      getMainProductForm()?.querySelector("input[name='id']");

    const getMainAtcButton = () =>
      getMainProductForm()?.querySelector("[type='submit'][name='add'], [data-add-to-cart]");

    /* ===== Initial copy from main form ===== */
    const mainPrice = document.querySelector(".regular-price, .price-item--regular, .product__price");
    const mainVariant = getMainVariantInput();
    if (mainPrice) priceEl.textContent = mainPrice.textContent.trim();
    if (mainVariant && hiddenId) hiddenId.value = mainVariant.value;

    /* ===== React to custom events ===== */
    document.addEventListener("variant:change", (e) => {
      const { id, available, formattedPrice } = e.detail || {};
      if (!id) return;

      hiddenId.value = id;
      hiddenId.setAttribute('value', id);

      // Handle formatted price: Remove negative prices if present
      if (formattedPrice) {
        let price = formattedPrice;
        if (price.startsWith('-')) {
          price = price.replace('-', ''); // Remove negative sign if present
        }
        priceEl.textContent = price;
      } else if (mainPrice) {
        const clone = mainPrice.cloneNode(true);
        clone.querySelectorAll('[aria-hidden="true"], .visually-hidden, .sr-only').forEach(el => el.remove());
        let clean = clone.textContent
          .replace(/Translation missing:[^\d$€£¥]+/gi, '')
          .replace(/\s+/g, ' ')
          .trim();

        // Remove "Regular Price" and clean the price
        clean = clean.replace(/Regular Price:.*$/, '').trim();

        // Check for negative prices and remove the negative sign if it exists
        if (clean.startsWith('-')) {
          clean = clean.replace('-', ''); // Remove the negative sign
        }

        priceEl.textContent = clean;
      }

      if (available) {
        stickyAtc.removeAttribute("disabled");
        stickyAtc.value = "Add to cart";
      } else {
        stickyAtc.setAttribute("disabled", "disabled");
        stickyAtc.value = "Sold out";
      }
    });

    document.addEventListener("price:change", (e) => {
      const { text } = e.detail || {};
      let clean = '';

      if (typeof text === 'string') clean = text;
      else if (text?.textContent) clean = text.textContent;

      clean = clean
        .replace(/Translation missing:[^\d$€£¥]+/gi, '')
        .replace(/\s+/g, ' ')
        .trim();

      // Clean up price by removing unwanted parts (like "Regular Price")
      clean = clean.replace(/Regular Price:.*$/, '').trim();

      // Check for negative prices and remove the negative sign if it exists
      if (clean.startsWith('-')) {
        clean = clean.replace('-', ''); // Remove the negative sign
      }

      if (!clean || priceEl.textContent.trim() === clean) return;

      // Guard against overlap
      priceEl.removeEventListener('transitionend', priceEl._listener);
      priceEl.classList.add('updating');

      priceEl._listener = (ev) => {
        if (ev.propertyName !== 'opacity') return;

        priceEl.textContent = clean;
        // Force reflow before showing again
        void priceEl.offsetWidth;
        priceEl.classList.remove('updating');
        priceEl.removeEventListener('transitionend', priceEl._listener);
      };

      priceEl.addEventListener('transitionend', priceEl._listener);
    });

    /* ===== Fallback: watch ID input 'change' from any form ===== */
    document.addEventListener("change", (e) => {
      const t = e.target;
      const mainVariantInput = getMainVariantInput();
      if (t && mainVariantInput && t === mainVariantInput) {
        hiddenId.value = t.value;
        hiddenId.setAttribute('value', t.value);
        // If no custom event fired, mirror current visible price
        const livePrice = document.querySelector(".regular-price, .price-item--regular, .product__price");
        if (livePrice) priceEl.textContent = livePrice.textContent.trim();
      }
    });

    /* ===== If sticky loads late, apply last cached payloads ===== */
    if (window.__lastVariantChange) {
      const e = new CustomEvent("variant:change", { detail: window.__lastVariantChange });
      document.dispatchEvent(e);
    }
    if (window.__lastPriceChange) {
      const e = new CustomEvent("price:change", { detail: window.__lastPriceChange });
      document.dispatchEvent(e);
    }

    /* ===== Show/hide with animation based on scroll direction ===== */
    let lastScrollY = window.scrollY || window.pageYOffset; // Track last scroll position
    let ticking = false;
    
    const toggleStickyVisibility = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY || window.pageYOffset; // Get the current scroll position
    
          // If scrolling down (current scroll position is greater than the last scroll position)
          if (scrollY > lastScrollY) {
            // Show sticky ATC
            stickyForm.classList.add("visible");
          } else {
            // If scrolling up (current scroll position is less than or equal to the last scroll position)
            // Hide sticky ATC
            stickyForm.classList.remove("visible");
          }
    
          // Update last scroll position to current one for the next scroll event
          lastScrollY = scrollY;
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener("scroll", toggleStickyVisibility);
    
    /* ===== Submit variant to cart ===== */
    stickyAtc?.addEventListener("click", (e) => {
      e.preventDefault();

      const mainForm = getMainProductForm();
      if (!mainForm) return;

      const stickyQty = parseInt(qtyInput.value) || 1;

      // Match quantity input or select in main form
      const mainQtyField = mainForm.querySelector('[name="quantity"]');
      const mainVariantInput = getMainVariantInput();

      // Sync quantity (works for both <input> and <select>)
      if (mainQtyField) {
        mainQtyField.value = stickyQty;
        mainQtyField.dispatchEvent(new Event('input', { bubbles: true }));
        mainQtyField.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Sync variant ID if needed
      if (mainVariantInput && hiddenId.value) {
        mainVariantInput.value = hiddenId.value;
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Let Shopify update any dependent scripts
      mainForm.dispatchEvent(new Event('change', { bubbles: true }));

      // Trigger the main Add to Cart button
      const mainAtcBtn = getMainAtcButton();
      if (mainAtcBtn) mainAtcBtn.click();
    });

    /* ===== Mirror main ATC loading state ===== */
    const mainAtc = getMainAtcButton();
    if (mainAtc) {
      const observer = new MutationObserver(() => {
        stickyAtc.classList.toggle('loading', mainAtc.classList.contains('loading'));
        stickyAtc.disabled = mainAtc.classList.contains('loading');
      });
      observer.observe(mainAtc, { attributes: true, attributeFilter: ['class'] });
    }

    /* ===== Quantity logic ===== */
    minus?.addEventListener("click", (e) => {
      e.preventDefault();
      const val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
    plus?.addEventListener("click", (e) => {
      e.preventDefault();
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });

    /* ===== Build sticky-only scroll titles ===== */
    const headings = document.querySelectorAll(".vertical-description .page-heading");
    if (headings.length) {
      headings.forEach((h, i) => {
        const span = document.createElement("span");
        span.className = "sticky-scrollTo";
        span.dataset.id = h.textContent.trim();
        span.textContent = h.textContent.trim();
        if (i === 0) span.classList.add("active");
        span.addEventListener("click", () => {
          window.scrollTo({ top: h.offsetTop - 150, behavior: "smooth" });
          titlesContainer.querySelectorAll(".sticky-scrollTo").forEach((el) => el.classList.remove("active"));
          span.classList.add("active");
        });
        titlesContainer.appendChild(span);
      });
    }

    /* ===== Sync sticky titles with scroll ===== */
    const sections = document.querySelectorAll(".vertical-description .page-heading");
    if (sections.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const id = entry.target.textContent.trim();
            const link = titlesContainer.querySelector(`.sticky-scrollTo[data-id='${id}']`);
            if (entry.isIntersecting) {
              titlesContainer.querySelectorAll(".sticky-scrollTo").forEach((el) => el.classList.remove("active"));
              if (link) link.classList.add("active");
            }
          });
        },
        { rootMargin: "-45% 0px -45% 0px" }
      );
      sections.forEach((sec) => observer.observe(sec));
    }

    /* ===== Scroll to top ===== */
    topBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
}

customElements.define("sticky-atc", StickyAtc);
